/* eslint-disable import/prefer-default-export */
export const SearchList = [
  { label: 'V.I.N.', value: 'vin' },
  { label: 'Référence', value: 'reference' },
];

export const SearchReferenceType = [
  { label: "Référence d'Origine (OE)", value: 1 },
  { label: 'Référence Tec Doc', value: 0 },
];

export const INIT_FILTERS = {
  copimaFamily: null,
  copimaBrand: null,
  tecdocFamily: null,
  tecdocBrand: null,
};

export const INIT_EXTRA_FILTERS = {
  carType: null,
  brand: null,
  model: null,
  engineType: null,
  engineCode: null,
};
